"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZebecCardInstructions = void 0;
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
/**
 * Zebec Card Instruction Factory
 */
class ZebecCardInstructions {
    constructor(program) {
        this.program = program;
    }
    /**
     * Gets transaction instruction to initialize card pda and set card config
     * @param cardPda Card Pda Account
     * @param usdcToken Usdc Mint Address
     * @param zicOwner Zebec Card Owner: Card Pda Authority
     * @param data Config Data
     * @returns
     */
    getInitCardConfigsInstruction(cardPda, usdcToken, zicOwner, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { revenueFee, solFee, tokenFee, cardVault, revenueVault } = data;
            return this.program.methods
                .initCardConfigs({ revenueFee, solFee, tokenFee, cardVault, revenueVault })
                .accounts({
                associatedTokenProgram: constants_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                cardPda,
                systemProgram: web3_js_1.SystemProgram.programId,
                tokenProgram: constants_1.TOKEN_PROGRAM_ID,
                usdcToken,
                zicOwner,
            })
                .instruction();
        });
    }
    /**
     * Gets transaction instruction to deposit USDC
     * @param buyer Depositor address: Buyer Pda Authority
     * @param buyerPda Unique program derived address for each deposit
     * @param buyerUsdcAta Depositor USDC token account
     * @param cardPda Card Pda
     * @param cardVault Card Vault address set in card config
     * @param cardVaultUsdcAta Card vault USDC token account
     * @param revenueVault Revenue vault address set in card config
     * @param revenueVaultUsdcAta Revenue vault USDC token account
     * @param usdcToken USDC mint address
     * @param zicOwner Zebec card pda authority
     * @param data Deposit data
     * @returns
     */
    getDepositToBuyCardInstruction(buyer, buyerPda, buyerUsdcAta, cardPda, cardVault, cardVaultUsdcAta, revenueVault, revenueVaultUsdcAta, usdcToken, zicOwner, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { amount, cardType, index, tokenType } = data;
            return this.program.methods
                .depositToBuyCard({
                amount,
                cardType,
                index,
                tokenType,
            })
                .accounts({
                associatedTokenProgram: constants_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                buyer,
                buyerPda,
                buyerUsdcAta,
                cardPda,
                cardVault,
                cardVaultUsdcAta,
                revenueVault,
                revenueVaultUsdcAta,
                systemProgram: web3_js_1.SystemProgram.programId,
                tokenProgram: constants_1.TOKEN_PROGRAM_ID,
                usdcToken,
                zicOwner,
            })
                .instruction();
        });
    }
    /**
     * Gets transaction instruction for updating card configs
     * @param cardPda Card Pda
     * @param zicOwner Card Pda authority
     * @param data Card config data
     * @returns
     */
    getSetCardConfigsInstruction(cardPda, zicOwner, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { revenueFee, solFee, tokenFee, cardVault, revenueVault } = data;
            return this.program.methods
                .setCardConfigs({
                revenueFee,
                solFee,
                tokenFee,
                cardVault,
                revenueVault,
            })
                .accounts({
                cardPda,
                zicOwner,
            })
                .instruction();
        });
    }
}
exports.ZebecCardInstructions = ZebecCardInstructions;
